import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const VerifyEmailPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await fetch(`/api/auth/verify-email/${token}`);
        if (res.ok) {
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch {
        setStatus('error');
      }
    };
    verify();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-[#003B73] mb-2">ByggFynd</h1>
        </div>
        {status === 'loading' && (
          <div className="flex flex-col items-center gap-4">
            <Loader2 className="h-12 w-12 animate-spin text-[#003B73]" />
            <p className="text-gray-600">Verifierar din e-postadress...</p>
          </div>
        )}
        {status === 'success' && (
          <div className="flex flex-col items-center gap-4">
            <CheckCircle className="h-16 w-16 text-green-500" />
            <h2 className="text-xl font-bold text-gray-900">E-postadressen verifierad!</h2>
            <p className="text-gray-600">Ditt konto är nu aktiverat. Du kan logga in.</p>
            <Button className="bg-[#003B73] hover:bg-[#002855] w-full" onClick={() => navigate('/logga-in')}>
              Logga in
            </Button>
          </div>
        )}
        {status === 'error' && (
          <div className="flex flex-col items-center gap-4">
            <XCircle className="h-16 w-16 text-red-500" />
            <h2 className="text-xl font-bold text-gray-900">Ogiltig länk</h2>
            <p className="text-gray-600">Verifieringslänken är ogiltig eller har gått ut.</p>
            <Button className="bg-[#003B73] hover:bg-[#002855] w-full" onClick={() => navigate('/logga-in')}>
              Tillbaka till login
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
